import React, { useContext, useEffect, useState } from 'react';
import { WebTagContext } from '../../context/WebTagContext';
import { environment } from '../../global/environment';
import { useFetch } from '../../hooks/useFetch';
import { useYears } from '../../hooks/useYears';
import { WebTagError } from '../web-tag-error/WebTagError';
import { ValidateCI } from '../../utils/validateCi';


export const WebTagStep2 = () => {

    const { step, userData, loading, setStep, setUserData } = useContext(WebTagContext);

    const { documentType,
        document,
        name1,
        name2,
        lastName1,
        lastName2,
        dob,
        sex,
        phone,
        cellphone,
        email } = userData;

    const { api_url, document_types_endpoint } = environment;

    const { response: documentTypes } = useFetch(api_url, document_types_endpoint);

    const validDob = useYears(dob);
    const validCI = documentType == 1 ? document.length < 7 ? false : ValidateCI(document) : true;

    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        setSubmitted(false)
    }, [step])

    const handleHeaderClick = () => {
        (step.current > 2 && step.current != 4) &&
            setStep({ current: 2 });
    }

    const handleChange = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        validDob && validCI &&
            setStep({
                current: 3
            });

    }

    return (
        <>
            <div className="step">
                <div className="step-header">
                    <a
                        onClick={handleHeaderClick}
                        className="title">
                        <span className={step.current > 2 ? "completed step-number" : "step-number"}>
                            <span>2</span>
                        </span>Identificación de la Persona
                    </a>
                </div>
                {
                    (step.current === 2 && documentTypes)
                    &&
                    <form
                        onSubmit={handleSubmit}>
                        <div className="step-container">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label className="label-holder first-child">
                                        <span className="label required">Tipo de documento</span>
                                        <span className="select-holder">
                                            <select
                                                className="select validate-required"
                                                name="documentType"
                                                onChange={handleChange}
                                                value={documentType}
                                                required>
                                                <option
                                                    disabled
                                                    data-placeholder
                                                    value="">
                                                    {
                                                        loading.document_types ?
                                                            'Cargando...' :
                                                            'Seleccione su tipo de documento'
                                                    }
                                                </option>
                                                {
                                                    documentTypes.map(
                                                        documentType => <option
                                                            value={documentType.id}
                                                            key={documentType.id} >
                                                            {documentType.name}
                                                        </option>
                                                    )
                                                }
                                            </select>
                                        </span>
                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <label className="label-holder second-child">

                                        <span className="label required">Número de documento</span>
                                        <input
                                            type="text"
                                            className="input validate-required"
                                            name="document"
                                            value={document}
                                            placeholder="Ingrese su cédula"
                                            data-minlength=""
                                            onChange={handleChange}
                                            required />

                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <label className="label-holder">

                                        <span className="label required">Primer nombre</span>

                                        <input
                                            type="text"
                                            className="input validate-required"
                                            name="name1"
                                            value={name1}
                                            placeholder="Ingrese su primer nombre"
                                            data-minlength=""
                                            onChange={handleChange}
                                            required />

                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <label className="label-holder">

                                        <span className="label">Segundo nombre</span>

                                        <input
                                            type="text"
                                            className="input"
                                            name="name2"
                                            value={name2}
                                            placeholder="Ingrese su segundo nombre"
                                            data-minlength=""
                                            onChange={handleChange} />

                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <label className="label-holder">

                                        <span className="label required">Primer apellido</span>

                                        <input
                                            type="text"
                                            className="input validate-required"
                                            name="lastName1"
                                            value={lastName1}
                                            placeholder="Ingrese su primer apellido"
                                            data-minlength=""
                                            onChange={handleChange}
                                            required />

                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <label className="label-holder">

                                        <span className="label required">Segundo apellido</span>

                                        <input
                                            type="text"
                                            className="input validate-required"
                                            name="lastName2"
                                            value={lastName2}
                                            placeholder="Ingrese su segundo apellido"
                                            data-minlength=""
                                            onChange={handleChange}
                                            required />

                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <div className="label-holder">

                                      <span className="label required">Fecha de nacimiento</span>

                                        <input
                                            type="date"
                                            className="input"
                                            name="dob"
                                            value={dob}
                                            onChange={handleChange} />

                                            {/*
                                        <div className="row">

                                            <div className="col-sm-4" style={{ width: "33.333%" }}>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    max="31"
                                                    step="1"
                                                    className="input validate-required"
                                                    name="dobDay"
                                                    value={dobDay}
                                                    placeholder="DD"
                                                    data-minlength=""
                                                    onChange={handleChange}
                                                    required />
                                            </div>
                                            <div className="col-sm-4" style={{ width: "33.333%" }}>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    max="12"
                                                    step="1"
                                                    className="input validate-required"
                                                    name="dobMonth"
                                                    value={dobMonth}
                                                    placeholder="MM"
                                                    data-minlength=""
                                                    onChange={handleChange}
                                                    required />
                                            </div>
                                            <div className="col-sm-4" style={{ width: "33.333%" }}>
                                                <input
                                                    type="number"
                                                    min="1922"
                                                    max="2004"
                                                    step="1"
                                                    className="input validate-required"
                                                    name="dobYear"
                                                    value={dobYear}
                                                    placeholder="YYYY"
                                                    data-minlength="4"
                                                    onChange={handleChange}
                                                    required />
                                            </div>

                                        </div>

                                            */}
                                    </div>
                                </div>
                                <div className="col-sm-6">

                                    <label className="label-holder">
                                        <span className="label required">Sexo</span>
                                        <span className="select-holder">
                                            <select
                                                className="select  validate-required"
                                                name="sex"
                                                onChange={handleChange}
                                                required
                                                value={sex}>
                                                <option
                                                    disabled
                                                    data-placeholder
                                                    value="">Seleccione su sexo</option>
                                                <option value="M">Masculino</option>
                                                <option value="F">Femenino</option>
                                            </select>
                                        </span>
                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <label className="label-holder">

                                        <span className="label required">Teléfono</span>

                                        <input
                                            type="tel"
                                            className="input  validate-required"
                                            name="phone"
                                            value={phone}
                                            placeholder="Ingrese su número de contacto"
                                            data-minlength=""
                                            onChange={handleChange}
                                            required
                                            pattern="[0-9]*$" />

                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <label className="label-holder">

                                        <span className="label required">Celular</span>

                                        <input
                                            type="tel"
                                            className="input  validate-required"
                                            name="cellphone"
                                            value={cellphone}
                                            placeholder="Ingrese su celular de contacto"
                                            data-minlength=""
                                            onChange={handleChange}
                                            required
                                            pattern="[0-9]*$" />

                                    </label>
                                </div>
                                <div className="col-sm-6">
                                    <label className="label-holder">
                                        <span className="label required">Email</span>
                                        <input
                                            type="email"
                                            className="input  validate-required validate-email"
                                            name="email"
                                            value={email}
                                            placeholder="Ingrese su email"
                                            data-minlength=""
                                            onChange={handleChange}
                                            required />
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div className="no-margin step-actions">
                            <button
                                type="submit"
                                className="btn-form">
                                Continuar
                            </button>
                        </div>
                    </form>
                }
            </div>
            {
                (submitted && !validDob ) &&
                <WebTagError title={'Fecha de nacimiento inválida'}
                    error={'La edad debe ser mayor o igual a 18 años'} />
            }
            {
                (submitted && !validCI ) &&
                <WebTagError title={'Documento inválido'}
                    error={'El documento no tiene el formato X.XXX.XXX-X o es inválido '} />
            }
        </>
    );
}
